import { useNavigate } from 'react-router-dom';

export function Python() {
  const navigate = useNavigate();

  // Platform data
  const platforms = [
    {
      name: 'YouTube Playlists',
      route: '/Backend_Py_Yt',
      img: 'https://thumbs.dreamstime.com/b/high-resolution-colored-youtube-logo-white-background-vector-eps-file-available-additional-download-colored-youtube-logo-175730434.jpg',
    },
    {
      name: 'Coursera',
      route: '/Backend_Py_Coursera',
      img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmVgLGfhr0DKM1D4bBSvZh9h6UdIG84qhbSsHAsn_P1KeOEa_wGqqbO9z1zcyn3atADVU&usqp=CAU',
    },
    {
      name: 'Udemy Courses',
      route: '/Backend_Py_Udemy',
      img: 'https://logowik.com/content/uploads/images/udemy-new-20212512.jpg',
    },
    {
      name: 'Geeks for Geeks',
      route: '/Backend_Py_Gfg',
      img: 'https://miro.medium.com/v2/resize:fit:799/0*yxCtOgS-v50Sqfzw.jpeg',
    },
    {
      name: 'Coding Platforms',
      route: '/Backend_Py_Codplat',
      img: 'https://img.freepik.com/premium-vector/continuous-line-building-city-logo-design_15473-14266.jpg?semt=ais_hybrid',
    },
  ];

  return (
    <>
      <h1 className="html_head">Links are below</h1>
      <p className="html_para">
        These are the platforms for your <strong>Python</strong> study purpose. Utilize these recommended platforms to gain knowledge. This is purely for <strong>educational purposes</strong>.
      </p>
      <h3 className="reco_html">Recommended Platforms</h3>

      {platforms.map((platform, index) => (
        <div className="container_html_pg" key={index}>
          <img
            className="html_logo_yt"
            style={{ height: '90px', width: '90px' }}
            src={platform.img}
            alt={platform.name}
          />
          <h5 style={{ margin: '30px 0px 0px 30px', fontFamily: 'Arial', fontWeight: 'bold' }}>
            {platform.name} &#9754;
          </h5>
          <div className="butt_yt">
            <button className="btn_html_yt" onClick={() => navigate(platform.route)}>
              Click Me
            </button>
          </div>
        </div>
      ))}
    </>
  );
}

export default Python;
